import { createSlice } from "@reduxjs/toolkit";

const initialRewardsLiveProductsState = {
  errorFound: false,
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  exportData: [],
  rewardsCategories: [],
  rewardsCategories1: [],
  rewardsVouchers: [],
  uploadimage: [],
  uploadimage2: [],
  imageField: [],
  imageField2: [],
  newRewardsLiveProduct: [],
  editRewardsLiveProduct: [],
  deletedRewardsLiveProduct: [],
  PositionListList: [],
  hostListList: [],
  countryList: [],
  currencyList: [],
  rewardProductCurrency: []
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const RewardsLiveProductsSlice = createSlice({
  name: "rewardsLiveProducts",
  initialState: initialRewardsLiveProductsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      state.errorFound = true;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      state.errorFound = false;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.errorFound = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.errorFound = false;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },

    rewardsLiveProductsList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;

      state.error = null;
      state.errorFound = false;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    PositionListList: (state, action) => {
      const { totalCount, entities } = action.payload;
      console.log("totalCount, entities slice", totalCount, entities);
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    rewardsLiveProductsExport: (state, action) => {
      const { exportData } = action.payload;
      // state.listLoading = false;
      // state.error = null;
      state.exportData = exportData;
    },
    staffUsersFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    rewardsCategoriesSearch: (state, action) => {
      const { rewardsCategories } = action.payload;
      state.error = null;
      state.errorFound = false;
      state.rewardsCategories = rewardsCategories;
    },
    rewardsCategoriesSearch1: (state, action) => {
      const { rewardsCategories1 } = action.payload;
    
      // Log the rewardsCategories1 data
      console.log(rewardsCategories1, "kfdngbfhgbfgjf");
    
      // Manipulate the data if needed
      // For example, you can filter out certain elements or modify properties here
    
      // Update the Redux state
      state.error = null;
      state.errorFound = false;
      state.rewardsCategories1 = rewardsCategories1;
    },
    
    rewardsVouchersSearch: (state, action) => {
      const { rewardsVouchers } = action.payload;
      state.error = null;
      state.errorFound = false;
      state.rewardsVouchers = rewardsVouchers;
    },
    uploadImage: (state, action) => {
      const { uploadimage, imageField } = action.payload;
      state.error = null;
      state.errorFound = false;
      state.uploadimage = uploadimage;
      state.imageField = imageField;
    },
    uploadImage2: (state, action) => {
      const { uploadimage2, imageField2 } = action.payload;
      state.error = null;
      state.errorFound = false;
      state.uploadimage2 = uploadimage2;
      state.imageField2 = imageField2;
    },
    createRewardsLiveProduct: (state, action) => {
      const { newRewardsLiveProduct } = action.payload;
      state.error = null;
      state.errorFound = false;
      state.newRewardsLiveProduct = newRewardsLiveProduct;
    },
    updateRewardsLiveProduct: (state, action) => {
      const { editRewardsLiveProduct } = action.payload;
      state.error = null;
      state.errorFound = false;
      state.editRewardsLiveProduct = editRewardsLiveProduct;
    },
    deleteRewardsLiveProduct: (state, action) => {
      const { deletedRewardsLiveProduct } = action.payload;
      state.error = null;
      state.errorFound = false;
      state.deletedRewardsLiveProduct = deletedRewardsLiveProduct;
    },
    CompanyList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.errorFound = false;
      state.companyList = entities;
      // state.totalCount = totalCount;
    },
    singleCompanyFetched: (state, action) => {
      state.actionsLoading = false;
      state.singleCompanyFetched = action.payload.singleCompanyFetched;
      state.error = null;
      state.errorFound = false;
    },
    CompanyDropdownList: (state, action) => {
      const { companyDropdownList } = action.payload;
      state.companyDropdownList = companyDropdownList;
    },
    CountryList: (state, action) => {
      const { countryList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.countryList = countryList;
    },
    CurrencyList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.currencyList = entities;
    },
    RewardProductCurrencyList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.rewardProductCurrency = entities;
    },
  },
});
